import { Big, type BigSource } from 'big.js';

export function abs(value: BigSource | undefined): string {
  if (!value) {
    return '0';
  }

  try {
    const asBig = new Big(value);
    return asBig.abs().toString();
  } catch {
    return '0';
  }
}
